import { render, staticRenderFns } from "./AddRecipe.vue?vue&type=template&id=6e1dad36&"
import script from "./AddRecipe.vue?vue&type=script&lang=js&"
export * from "./AddRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports